import React, { createContext, useState, useRef } from 'react';

export interface TreeNodeFetcher {
  [nodeId: string]: Function;
}

export interface FileExplorerContextProps {
  selected?: string;
  setSelected: (nodeId?: string) => void;
  refresh?: () => void;
  setRefresh: (refreshFn: () => void) => void;
  refreshNode: (nodeId: string) => void;
  setTreeNodeFetcher: (nodeId: string, fetcher: Function) => void;
}

export const FileExplorerContext = createContext<FileExplorerContextProps>({
  setSelected: () => {},
  setRefresh: () => {},
  refreshNode: () => {},
  setTreeNodeFetcher: () => {}
});

export const FileExplorerProvider: React.FC = ({ children }) => {
  const refreshRef = useRef<(() => void) | undefined>();
  // save api function requests of individual children node here
  const treeNodeFetcherRef = useRef<TreeNodeFetcher>({});
  const [selected, setSelected] = useState<string | undefined>();

  const refresh = () => refreshRef.current?.();
  const setRefresh = (refreshFn: () => void) => {
    refreshRef.current = refreshFn;
  };
  const refreshNode = () => {
    // refresh everything
    for (const [, fetcher] of Object.entries(treeNodeFetcherRef.current)) {
      fetcher();
    }
  };
  const setTreeNodeFetcher = (nodeId: string, fetcher: Function) => {
    treeNodeFetcherRef.current[nodeId] = () => fetcher(nodeId);
  };

  return (
    <FileExplorerContext.Provider
      value={{
        selected,
        setSelected,
        refresh,
        setRefresh,
        refreshNode,
        setTreeNodeFetcher
      }}
    >
      {children}
    </FileExplorerContext.Provider>
  );
};
